module.exports = __webpack_public_path__ + "img/9.8f51d176.jpg";